var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRainmakerSoftIcon30RemindMinute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "current",
    viewBox: "0 0 33.1 33.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3 4.5c0-.4.3-.8.8-.8H23c.4 0 .8.3.8.8s-.4.8-.8.8H9.1c-.4 0-.8-.3-.8-.8zm21.1 21.2c0 2.7-2.2 4.8-4.8 4.8-1.6 0-3-.8-3.9-2H9.1c-.4 0-.8-.3-.8-.8s.4-.7.8-.7h10.8c-.1-.4-.2-.8-.2-1.3h-9.4c-1.1 0-2-.9-2-2.2 0-3.4 1.4-5.9 4-7.4-2.7-1.5-4-4-4-7.4 0-1.2.9-2.2 2-2.2h11.4c1.1 0 2 .9 2 2.2 0 3.4-1.4 5.9-4 7.4 1.9 1.1 3.2 2.7 3.7 4.8.3-.1.7-.1 1.1-.1 2.7.1 4.9 2.2 4.9 4.9zm-19.1-1.5H20c.4-1.1 1.1-2 2.1-2.6-.5-2.2-1.9-3.8-4.4-4.7-.3-.1-.5-.4-.5-.7 0-.3.2-.6.5-.7 3.1-1.2 4.6-3.3 4.6-6.7 0-.4-.2-.7-.5-.7H10.3c-.3 0-.5.3-.5.7 0 3.4 1.5 5.5 4.6 6.7.3.1.5.4.5.7 0 .3-.2.6-.5.7-3.1 1.2-4.6 3.3-4.6 6.7 0 .3.3.6.5.6zm17.6 1.5c0-1.8-1.5-3.3-3.3-3.3-1.8 0-3.3 1.5-3.3 3.3s1.5 3.3 3.3 3.3c1.8 0 3.3-1.5 3.3-3.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainmakerSoftIcon30RemindMinute);
export default __webpack_public_path__ + "static/media/Rainmaker_soft_icon_30_RemindMinute.6a0443e0.svg";
export { ForwardRef as ReactComponent };